export default {

	// Stores

	async page_list () {

		const [ stores, company_groups ] = await Promise.all([
			Anvil.models.haccp.StoreList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		const search = new Anvil.models.Record({
			company_group_id: null
		})

		await Anvil.renderPage('/haccp/page_list', { stores, company_groups, search })
	},

	async action_refresh () {

		const [ stores, company_groups ] = await Promise.all([
			Anvil.models.haccp.StoreList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.page.stores = stores
		Anvil.page.company_groups = company_groups
		const grid = Anvil.models.components.Grid.find('#store_grid')
		if (grid) {
			grid.list = stores
		}
	},

	async modal_edit (store_data) {

		const store = new Anvil.models.haccp.Store(store_data)

		await Anvil.modal('/haccp/modal_edit', { store })
	},

	async action_save (store) {

		// Tell the record to commit
		await store.record.commit()

		Anvil.toast.success('Elmentve', 'A telephely mentése sikeres')

		// Refresh list
		await this.action_refresh()

		// Focus on company
		const grid = Anvil.models.components.Grid.find('#store_grid')
		if (grid) {
			grid.select(grid.list.data.find(c => c.machine_id == store.machine_id), true)
		}

		return true
	},

	// Devices

	async page_device_list () {

		const [ devices, company_groups ] = await Promise.all([
			Anvil.models.haccp.DeviceList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		const search = new Anvil.models.Record({
			company_group_id: null
		})

		await Anvil.renderPage('/haccp/page_device_list', { devices, company_groups, search })
	},

	async action_refresh_devices () {

		const [ devices, company_groups ] = await Promise.all([
			Anvil.models.haccp.DeviceList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.page.devices = devices
		Anvil.page.company_groups = company_groups
		const grid = Anvil.models.components.Grid.find('#device_grid')
		if (grid) {
			grid.list = devices
		}
	},

	async modal_edit_device (device_data) {

		const device = new Anvil.models.haccp.Device(device_data)

		await Anvil.modal('/haccp/modal_edit_device', { device })
	},

	async action_save_device (device) {

		// Tell the record to commit
		await device.record.commit()

		Anvil.toast.success('Elmentve', 'A telephely mentése sikeres')

		// Refresh list
		await this.action_refresh_devices()

		// Focus on company
		const grid = Anvil.models.components.Grid.find('#device_grid')
		if (grid) {
			grid.select(grid.list.data.find(c => c.machine_id == device.machine_id), true)
		}

		return true
	},

}